"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var _indexOf = require('lodash/indexOf');
var Option = antd_1.Select.Option;
/**
 * Combobox offering different filter operators.
 */
var OperatorCombo = /** @class */ (function (_super) {
    __extends(OperatorCombo, _super);
    function OperatorCombo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value
        };
        return _this;
    }
    OperatorCombo.getDerivedStateFromProps = function (nextProps, prevState) {
        var value = nextProps.value;
        // check if we have to change value according to new allowed operators
        if (nextProps.operators) {
            if (_indexOf(nextProps.operators, nextProps.value) === -1) {
                // current operator is not in allowed list, so we use an allowed one
                value = nextProps.operators[0];
            }
        }
        return {
            value: value
        };
    };
    OperatorCombo.prototype.render = function () {
        var _this = this;
        var options = [];
        var operators = this.props.operators || ['==', '*=', '!=', '<', '<=', '>', '>='];
        // create an option per attribute
        options = operators.map(function (operator) {
            var title = _this.props.showTitles
                ? _this.props.operatorTitleMappingFunction(operator)
                : ' ';
            return (React.createElement(Option, { key: operator, value: operator, title: title }, _this.props.operatorNameMappingFunction(operator)));
        });
        var helpTxt = this.props.validateStatus !== 'success' ? this.props.help : null;
        return (React.createElement("div", { className: "gs-operator-combo" },
            React.createElement(antd_1.Form.Item, { label: this.props.label, colon: false, validateStatus: this.props.validateStatus, help: helpTxt },
                React.createElement(antd_1.Select, { value: this.state.value, style: { width: '100%' }, onChange: this.props.onOperatorChange, placeholder: this.props.placeholder }, options))));
    };
    OperatorCombo.defaultProps = {
        label: 'Operator',
        showTitles: true,
        placeholder: 'Select Operator',
        value: undefined,
        operators: ['==', '*=', '!=', '<', '<=', '>', '>='],
        operatorNameMappingFunction: function (n) { return n; },
        operatorTitleMappingFunction: function (t) { return t; },
        validateStatus: 'error',
        help: 'Please select an operator.'
    };
    return OperatorCombo;
}(React.Component));
exports.OperatorCombo = OperatorCombo;
exports.default = OperatorCombo;
//# sourceMappingURL=OperatorCombo.js.map